var ontologyColumns = require('../../../../models/equipment/ontologyColumns');
var ontologyFields = require('../../../../models/equipment/ontologyFields');

function trimString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function cloneJson(value) {
  if (typeof value === 'undefined') return undefined;
  return JSON.parse(JSON.stringify(value));
}

function hasDatasetNamed(datasets, datasetName) {
  var targetName = trimString(datasetName);
  if (!targetName) return false;
  return (Array.isArray(datasets) ? datasets : []).some(function (dataset) {
    return trimString(dataset && dataset.name) === targetName;
  });
}

function normalizeInheritedDataset(dataset, definedBy) {
  var normalizedDataset = ontologyColumns.normalizeDatasetDefinition(dataset);
  if (!normalizedDataset) return null;

  normalizedDataset.definedBy = definedBy;
  normalizedDataset.columns = ontologyColumns.normalizeColumnDefinitions(normalizedDataset.columns)
    .map(function (column) {
      return Object.assign({}, column, {
        definedBy: definedBy
      });
    });
  return normalizedDataset;
}

function mergeInheritedDataset(parentDatasetsArray, inheritedDataset) {
  if (!inheritedDataset || !inheritedDataset.name) return;
  var existingDatasetIdx = parentDatasetsArray.findIndex(function (dataset) {
    return trimString(dataset && dataset.name) === inheritedDataset.name;
  });

  if (existingDatasetIdx !== -1) {
    parentDatasetsArray[existingDatasetIdx] = ontologyColumns.mergeDatasetDefinitions(
      Object.assign({}, inheritedDataset),
      parentDatasetsArray[existingDatasetIdx]
    );
    return;
  }

  parentDatasetsArray.push(inheritedDataset);
}

function includeClassDatasetsAsInherited(classRecord, parentDatasetsArray) {
  if (!classRecord || !classRecord.name || !classRecord.data || !Array.isArray(classRecord.data.datasets)) return;

  classRecord.data.datasets.forEach(function (dataset) {
    var inheritedDataset = normalizeInheritedDataset(dataset, classRecord.name);
    mergeInheritedDataset(parentDatasetsArray, inheritedDataset);
  });
}

function includeClassFieldsAsInherited(classRecord, parentFieldsArray) {
  if (!classRecord || !classRecord.name || !classRecord.data || !Array.isArray(classRecord.data.fields)) return;

  ontologyFields.normalizeFieldDefinitions(classRecord.data.fields).forEach(function (field) {
    var fieldName = ontologyFields.getFieldName(field);
    if (!fieldName) return;

    var inheritedField = Object.assign({}, field, {
      definedBy: classRecord.name
    });
    var existingIdx = parentFieldsArray.findIndex(function (parentField) {
      return parentField && parentField.name === fieldName;
    });

    if (existingIdx !== -1) {
      parentFieldsArray[existingIdx] = Object.assign({}, parentFieldsArray[existingIdx], inheritedField);
      return;
    }

    parentFieldsArray.push(inheritedField);
  });
}

function includeClassPortsAsInherited(classRecord, parentPortsArray) {
  if (!classRecord || !classRecord.name || !classRecord.data || !Array.isArray(classRecord.data.ports)) return;

  classRecord.data.ports.forEach(function (port) {
    if (!port || typeof port !== 'object') return;
    parentPortsArray.push(Object.assign({}, cloneJson(port), {
      definedBy: classRecord.name
    }));
  });
}

function includeClassDataAsInheritedParent(classRecord, parentDatasetsArray, parentFieldsArray, parentPortsArray) {
  includeClassDatasetsAsInherited(classRecord, parentDatasetsArray);
  includeClassFieldsAsInherited(classRecord, parentFieldsArray);
  includeClassPortsAsInherited(classRecord, parentPortsArray);
}

module.exports = {
  hasDatasetNamed: hasDatasetNamed,
  includeClassDataAsInheritedParent: includeClassDataAsInheritedParent
};
